import { useCallback } from 'react';
import { aggErrors, fiMigrationSelectors } from 'app-components/flux/account-discovery';
import type { InstitutionLogin } from 'app-components/flux/institution-logins/institutionLoginsTypes';
import { useAppDispatch, useAppSelector } from 'hooks/redux';

type ConnectionUpdate = { institutionLogin: InstitutionLogin | undefined; onUpdate: () => void };
type ConnectionUpdateOrigin = {
  entry: string;
  location: 'account settings' | 'account list';
};

/** Reuses the migration action so every ingress keeps the same authentication and linking contract. */
export default function useConnectionUpdate(
  institutionLoginId: string | undefined,
  { entry, location }: ConnectionUpdateOrigin,
): ConnectionUpdate {
  const dispatch = useAppDispatch();
  const institutionLogin = useAppSelector(
    (state) => fiMigrationSelectors.getFiMigrationOfferByLogin(state, institutionLoginId)?.institutionLogin,
  );
  const action = useAppSelector((state) => fiMigrationSelectors.getFiMigrationAction(state, institutionLoginId, entry));
  const onUpdate = useCallback((): void => {
    if (institutionLogin && action) {
      aggErrors.kickoffAggAction(dispatch, action, institutionLogin, location);
    }
  }, [dispatch, institutionLogin, action, location]);
  return { institutionLogin, onUpdate };
}
